import { notify, can_visit, role_has } from "../helpers";
import { checkUnityEhrCredentials } from "../services/profile";

export const setupUserProfileData = async (practiceInfo, { navigate }) => {
  // if (can_visit("ehr_veradigm") && practiceInfo?.is_provider === true && role_has("Specialist")) {
  if (can_visit("ehr_veradigm") && practiceInfo?.accounts[0]?.practices[0]?.emr_type === "VeradigmEHR") {
    if (!practiceInfo?.ehr_type || !practiceInfo?.ehr_username) {
      navigate("/connect-veradigm", { replace: true });
      return true;
    } else {
      const paramsData = {
        account_id: practiceInfo?.accounts[0]?.practices[0]?.account_id,
        user_id: practiceInfo?.user_id,
        ehr_username: "skip",
        ehr_password: "skip",
      };

      const res = await checkUnityEhrCredentials(paramsData);
      if (res && res?.data?.status !== "success") {
        notify("error", "Please update the EHR credentials.", 2);
        navigate("/connect-veradigm", { replace: true });
        return true;
      }
    }
  }

  return false; // no redirect
};
